import { useEffect } from "react";
import { fetchExtrasDefaults } from "./ExtraServicesEditor";

// Shows the urgency surcharge input only when urgency === "urgente";
// auto-applies the admin default price the first time it appears with an empty cost.
export default function UrgencyCostInput({ urgency, value, onChange, compact = false, testId = "urgency-cost" }) {
  const active = urgency === "urgente";
  const empty = !(parseFloat(value) > 0);

  useEffect(() => {
    if (!active || !empty) return;
    fetchExtrasDefaults().then((d) => { if (d?.urgency_cost > 0) onChange(d.urgency_cost); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active]);

  if (!active) return null;
  return (
    <div>
      <label className={compact ? "block text-[10px] uppercase text-zinc-400 mb-1" : "block text-xs font-bold tracking-widest uppercase text-red-600 mb-1 font-heading"}>
        Costo urgenza (EUR)
      </label>
      <input
        type="number" step="0.01" min="0"
        value={value ?? ""}
        placeholder="es. 30.00"
        onChange={(e) => onChange(e.target.value === "" ? "" : parseFloat(e.target.value) || 0)}
        className={compact
          ? "w-full h-9 px-2 border border-red-300 rounded-sm text-sm focus:border-red-500 outline-none"
          : "w-full h-10 px-3 border border-red-300 rounded-sm text-sm focus:border-red-500 outline-none bg-white"}
        data-testid={testId}
      />
    </div>
  );
}
